module.exports = __webpack_public_path__ + "img/C303.6d0625c8.png";